export default {
  title: {
    en: 'Betslip',
  },
  titleActive: {
    en: 'Bet now',
  },
}
